export const getAvailableSlots = slots => slots.filter(slot => slot.availability > 0);

export const getSlotSelectionProperties = slots => {
  const visibleSlots = slots;
  const availableSlots = getAvailableSlots(slots);
  const busySlots = availableSlots.filter(slot => slot.isBusy);
  return {
    visibleSlots: visibleSlots.length,
    availableSlots: availableSlots.length,
    busySlots: busySlots.length,
  };
};
